import { Grid } from "antd";

export const useIsScreenLargerThanSm = () => {
  const breakpoints = Grid.useBreakpoint();
  return !!breakpoints.sm;
};
